webpackJsonp([1],{

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_layout_vue__ = __webpack_require__(530);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c39bcbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_layout_vue__ = __webpack_require__(561);
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c39bcbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_app_sidebar__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_app_contact__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_app_footer__ = __webpack_require__(557);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function onScroll() {
	this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
}

function onResize() {
	this.windowSize = { x: window.innerWidth, y: window.innerHeight };
}

function changeActive() {
	this.active = !this.active;
}

function closeModal() {
	if (this.$route.name === 'page-pillars') {
		this.$router.push({ name: 'page-home' });
		this.active = false;
	}
	this.active = false;
}

function data() {
	return {
		active: false,
		offsetTop: 0,
		windowSize: {
			x: 0,
			y: 0
		},
		items: [{
			id: 1,
			name: '¿QUIÉNES SOMOS?',
			href: '#description'
		}, {
			id: 2,
			name: 'PILARES RUNN',
			link: 'pillars'
		}, {
			id: 3,
			name: 'NUESTROS PRODUCTOS',
			href: '#our-products'
		}, {
			id: 4,
			name: 'NUESTRO TEAM',
			href: '#our-team'
		}, {
			id: 5,
			name: 'CONTÁCTANOS',
			href: '#app-contact'
		}],
		information: [{
			id: 1,
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/pin.svg',
			name: 'Calle Independencia 120 Miraflores- Lima - Perú'
		}, {
			id: 2,
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/phone+(1).svg',
			name: '(01)543-6575'
		}, {
			id: 3,
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/email.svg',
			name: 'info@apprunn.com'
		}],
		logosCompany: [{
			id: 1,
			name: 'Gittrack',
			logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/gittrack.svg',
			width: '80px'
		}, {
			id: 2,
			name: 'japisale',
			logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/japisale.svg',
			width: '86px'
		}, {
			id: 3,
			name: 'quipu',
			logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/quipu.svg',
			width: '73px'
		}, {
			id: 4,
			name: 'controlinn',
			logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/controlinn.svg',
			width: '96px'
		}, {
			id: 5,
			name: 'smart',
			logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/smart.svg',
			width: '80px'
		}, {
			id: 6,
			name: 'perudatos',
			logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/perudatos.svg',
			width: '83px'
		}, {
			id: 7,
			name: 'feedbackinn',
			logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/feedbackinn.svg',
			width: '85px'
		}],
		linksFooter: [{
			id: 1,
			name: 'NOSOTROS',
			items: [{
				id: 1,
				name: '¿Quienes somos?',
				href: '#description'
			}, {
				id: 2,
				name: 'Nuestro Equipo',
				href: '#our-team'
			}, {
				id: 3,
				name: 'Nuestros productos',
				href: '#our-products'
			}]
		}, {
			id: 2,
			name: 'BLOG',
			items: [{
				id: 1,
				name: 'Tema 1',
				href: ''
			}]
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-layout',
	data: data,
	components: {
		appContact: __WEBPACK_IMPORTED_MODULE_1__components_home_app_contact__["a" /* default */],
		appFooter: __WEBPACK_IMPORTED_MODULE_2__components_home_app_footer__["a" /* default */],
		appSidebar: __WEBPACK_IMPORTED_MODULE_0__components_home_app_sidebar__["a" /* default */]
	},
	methods: {
		changeActive: changeActive,
		closeModal: closeModal,
		onScroll: onScroll,
		onResize: onResize
	}
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function closeModal(item) {
	this.$emit('close-modal', item);
}

function changeActive() {
	this.$emit('change-active');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-sidebar',
	methods: {
		closeModal: closeModal,
		changeActive: changeActive
	},
	props: {
		items: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		active: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_form_contact__ = __webpack_require__(552);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-contact',
	components: {
		formContact: __WEBPACK_IMPORTED_MODULE_0__components_home_form_contact__["a" /* default */]
	},
	props: {
		information: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	}
});

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var submitForm = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						body = {
							companyId: 'undefined',
							data: {
								email: this.form.email,
								from: 'undefined',
								fullName: this.form.name,
								message: '"undefined"',
								to: 'undefined',
								commentary: this.form.commentary
							},
							templateCode: 'undefined'
						};
						_context.prev = 1;
						_context.next = 4;
						return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('undefined' + '/notifications/EMAIL/public', body);

					case 4:
						this.informationCustomer();
						this.showNotification('Su información ha sido enviada correctamente.');
						_context.next = 11;
						break;

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](1);

						if (_context.t0.status === 500) {
							this.showGenericError();
						}

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 8]]);
	}));

	return function submitForm() {
		return _ref.apply(this, arguments);
	};
}();

var informationCustomer = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						body = {
							companyId: 'undefined',
							data: {
								email: 'undefined',
								from: 'undefined',
								fullName: this.form.name,
								message: '"undefined"',
								to: this.form.email,
								commentary: this.form.commentary
							},
							templateCode: 'undefined'
						};
						_context2.prev = 1;
						_context2.next = 4;
						return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('undefined' + '/notifications/EMAIL/public', body);

					case 4:
						this.clearForm();
						_context2.next = 10;
						break;

					case 7:
						_context2.prev = 7;
						_context2.t0 = _context2['catch'](1);

						if (_context2.t0.status === 500) {
							this.showGenericError();
						}

					case 10:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 7]]);
	}));

	return function informationCustomer() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function disabled() {
	return !this.form.name || !this.form.email || !this.form.commentary;
}

function clearForm() {
	this.form = {
		email: '',
		name: '',
		message: ''
	};
}

function data() {
	return {
		form: {
			email: '',
			name: '',
			message: ''
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'form-contact',
	data: data,
	methods: {
		clearForm: clearForm,
		informationCustomer: informationCustomer,
		submitForm: submitForm
	},
	computed: {
		disabled: disabled
	}
});

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		links: [{
			id: 1,
			name: 'facebook',
			link: 'https://es-la.facebook.com/apprunn/',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/facebook+(1).svg',
			width: 15
		}, {
			id: 2,
			name: 'instagram',
			link: 'https://www.instagram.com/apprunn/?igshid=1qlz6flo9sst4',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/instagram-sketched.svg',
			width: 19
		}, {
			id: 3,
			name: 'linkedin',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/linkedin+(1).svg',
			link: 'https://www.linkedin.com/company/apprunn',
			width: 19
		}, {
			id: 4,
			name: 'youtube',
			link: 'https://www.youtube.com/channel/UCXfyVSRRJbBL1bUGbRqJCSA?disable_polymer=true&nv=1',
			width: 14,
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/play+(2).svg'
		}]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-footer',
	data: data,
	props: {
		logosCompany: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		linksFooter: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		windowSize: {
			type: Object,
			default: function _default() {}
		}
	}
});

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__ = __webpack_require__(531);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae0cccea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__ = __webpack_require__(548);
function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae0cccea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae0cccea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(547);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("91b51370", content, true);

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".app-sidebar[data-v-ae0cccea]{padding:60px 0 0 58px;position:absolute;z-index:44}@media (max-width:1024px){.app-sidebar[data-v-ae0cccea]{padding:34px 26px}}.app-sidebar.open[data-v-ae0cccea]{background-color:#fff;-webkit-box-shadow:0 2px 37px 0 rgba(0,0,0,.5);box-shadow:0 2px 37px 0 rgba(0,0,0,.5);height:100vh;padding:46px 0 0 44px;position:fixed;width:321px}@media (max-width:960px){.app-sidebar.open[data-v-ae0cccea]{padding:30px 0 0 28px;width:calc(100vw - 60px)}}.app-sidebar.open .return-home[data-v-ae0cccea]{display:block}.app-sidebar.open .border-sidebar[data-v-ae0cccea]{background-color:#05316a;height:32%;margin:11px 0 0 4px;width:1px}@media (max-width:960px){.app-sidebar.open .border-sidebar[data-v-ae0cccea]{height:160px}}@media (max-width:415px) and (min-width:375px){.app-sidebar.open .border-sidebar[data-v-ae0cccea]{height:29%}}@media (max-width:325px){.app-sidebar.open .border-sidebar[data-v-ae0cccea]{height:135px}}@media (min-width:765px) and (max-width:850px){.app-sidebar.open .border-sidebar[data-v-ae0cccea]{height:35%}}.app-sidebar.open .btn-menu[data-v-ae0cccea]{position:relative;right:6px}.name-links[data-v-ae0cccea]{color:#05316a;font-family:Lato,sans-serif;font-weight:400;font-size:16px;text-decoration:none}.circle-css[data-v-ae0cccea]{background-color:#05316a;border-radius:50%;height:9px;width:9px}.menu-container[data-v-ae0cccea]{background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item-links:hover .circle-css[data-v-ae0cccea]{background-color:#3bb4c1}.item-links:hover .name-links[data-v-ae0cccea]{color:#3bb4c1;font-family:Lato,sans-serif;font-weight:700;font-size:18px}.return-home[data-v-ae0cccea]{color:#05316a;display:none;font-family:Lato,sans-serif;font-weight:700;font-size:25px;position:absolute;text-decoration:none;right:25px;top:42px}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/app-sidebar.vue"],"names":[],"mappings":"AACA,8BACE,sBAAuB,AACvB,kBAAmB,AACnB,UAAY,CACb,AACD,0BACA,8BACM,iBAAmB,CACxB,CACA,AACD,mCACI,sBAA0B,AAC1B,+CAAoD,AAC5C,uCAA4C,AACpD,aAAc,AACd,sBAAuB,AACvB,eAAgB,AAChB,WAAa,CAChB,AACD,yBACA,mCACQ,sBAAuB,AACvB,wBAA0B,CACjC,CACA,AACD,gDACM,aAAe,CACpB,AACD,mDACM,yBAA0B,AAC1B,WAAY,AACZ,oBAAqB,AACrB,SAAW,CAChB,AACD,yBACA,mDACU,YAAc,CACvB,CACA,AACD,+CACA,mDACU,UAAY,CACrB,CACA,AACD,yBACA,mDACU,YAAc,CACvB,CACA,AACD,+CACA,mDACU,UAAY,CACrB,CACA,AACD,6CACM,kBAAmB,AACnB,SAAW,CAChB,AACD,6BACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,oBAAsB,CACvB,AACD,6BACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAY,AACZ,SAAW,CACZ,AACD,iCACE,sBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,+CACE,wBAA0B,CAC3B,AACD,+CACE,cAAe,AACf,4BAAgC,AAChC,gBAAkB,AAClB,cAAgB,CACjB,AACD,8BACE,cAAe,AACf,aAAc,AACd,4BAAgC,AAChC,gBAAkB,AAClB,eAAgB,AAChB,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,QAAU,CACX","file":"app-sidebar.vue","sourcesContent":["\n.app-sidebar[data-v-ae0cccea] {\n  padding: 60px 0 0 58px;\n  position: absolute;\n  z-index: 44;\n}\n@media (max-width: 1024px) {\n.app-sidebar[data-v-ae0cccea] {\n      padding: 34px 26px;\n}\n}\n.app-sidebar.open[data-v-ae0cccea] {\n    background-color: #ffffff;\n    -webkit-box-shadow: 0 2px 37px 0 rgba(0, 0, 0, 0.5);\n            box-shadow: 0 2px 37px 0 rgba(0, 0, 0, 0.5);\n    height: 100vh;\n    padding: 46px 0 0 44px;\n    position: fixed;\n    width: 321px;\n}\n@media (max-width: 960px) {\n.app-sidebar.open[data-v-ae0cccea] {\n        padding: 30px 0 0 28px;\n        width: calc(100vw - 60px);\n}\n}\n.app-sidebar.open .return-home[data-v-ae0cccea] {\n      display: block;\n}\n.app-sidebar.open .border-sidebar[data-v-ae0cccea] {\n      background-color: #05316a;\n      height: 32%;\n      margin: 11px 0 0 4px;\n      width: 1px;\n}\n@media (max-width: 960px) {\n.app-sidebar.open .border-sidebar[data-v-ae0cccea] {\n          height: 160px;\n}\n}\n@media (max-width: 415px) and (min-width: 375px) {\n.app-sidebar.open .border-sidebar[data-v-ae0cccea] {\n          height: 29%;\n}\n}\n@media (max-width: 325px) {\n.app-sidebar.open .border-sidebar[data-v-ae0cccea] {\n          height: 135px;\n}\n}\n@media (min-width: 765px) and (max-width: 850px) {\n.app-sidebar.open .border-sidebar[data-v-ae0cccea] {\n          height: 35%;\n}\n}\n.app-sidebar.open .btn-menu[data-v-ae0cccea] {\n      position: relative;\n      right: 6px;\n}\n.name-links[data-v-ae0cccea] {\n  color: #05316a;\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  text-decoration: none;\n}\n.circle-css[data-v-ae0cccea] {\n  background-color: #05316a;\n  border-radius: 50%;\n  height: 9px;\n  width: 9px;\n}\n.menu-container[data-v-ae0cccea] {\n  background-color: #ffffff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.item-links:hover .circle-css[data-v-ae0cccea] {\n  background-color: #3bb4c1;\n}\n.item-links:hover .name-links[data-v-ae0cccea] {\n  color: #3bb4c1;\n  font-family: 'Lato', sans-serif;\n  font-weight: bold;\n  font-size: 18px;\n}\n.return-home[data-v-ae0cccea] {\n  color: #05316a;\n  display: none;\n  font-family: 'Lato', sans-serif;\n  font-weight: bold;\n  font-size: 25px;\n  position: absolute;\n  text-decoration: none;\n  right: 25px;\n  top: 42px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"app-sidebar",class:{ 'open': _vm.active },attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.$route.name === 'page-home')?_c('button',{staticClass:"btn-menu btn-auto pa-0",on:{"click":_vm.changeActive}},[_c('img',{attrs:{"src":_vm.active ? 
				'https://web-apprunn.s3-sa-east-1.amazonaws.com/close.svg' :
				'https://web-apprunn.s3-sa-east-1.amazonaws.com/open-menu.svg',"alt":"cerrar menu","width":"24"}})]):_c('button',{staticClass:"btn-menu btn-auto pa-0",on:{"click":_vm.changeActive}},[_c('img',{attrs:{"src":_vm.active ?
					'https://web-apprunn.s3-sa-east-1.amazonaws.com/close.svg' : 
					'https://web-apprunn.s3-sa-east-1.amazonaws.com/menu-blue.svg',"width":"24"}})]),_vm._v(" "),(_vm.$route.name === 'page-pillars')?_c('router-link',{staticClass:"return-home",class:{ 'open': _vm.active },attrs:{"to":"/"}},[_vm._v("\n\t\t\t\tVolver\n\t\t\t")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"border-sidebar"}),_vm._v(" "),(_vm.active)?_c('v-flex',{staticClass:"menu-container",attrs:{"d-flex":"","xs12":"","md-4":"","column":""}},_vm._l((_vm.items),function(item,index){return _c('v-flex',{key:index,staticClass:"item-links",attrs:{"align-center":"","d-flex":""}},[_c('v-flex',{attrs:{"xs1":"","pt-3":""}},[_c('p',{staticClass:"circle-css"})]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[(item.href)?_c('a',{staticClass:"name-links",attrs:{"href":item.href}},[_c('button',{on:{"click":function($event){_vm.closeModal(item)}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t")])]):_c('router-link',{staticClass:"name-links",attrs:{"to":item.link}},[_c('button',{on:{"click":_vm.closeModal}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t")])])],1)],1)}),1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"border-sidebar"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_contact_vue__ = __webpack_require__(532);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47aedbee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_contact_vue__ = __webpack_require__(556);
function injectStyle (ssrContext) {
  __webpack_require__(550)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47aedbee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47aedbee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(551);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("247c28dc", content, true);

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".name-contactanos[data-v-47aedbee]{color:#05316a;font-family:Lato,sans-serif;font-weight:900;font-size:40px;margin-bottom:68px}@media (max-width:1024px){.name-contactanos[data-v-47aedbee]{font-size:30px;margin-bottom:43px;text-align:center}}.app-contact[data-v-47aedbee]{background-color:#fff;position:relative}@media (max-width:1024px){.app-contact[data-v-47aedbee]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:59px}}.item-information[data-v-47aedbee]{color:#05316a;font-family:Lato,sans-serif;font-weight:300;font-size:20px;margin:0 0 0 14px;width:300px}@media (max-width:1024px){.item-information[data-v-47aedbee]{text-align:center}}.content-information[data-v-47aedbee]{margin-bottom:35px}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/app-contact.vue"],"names":[],"mappings":"AACA,mCACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,kBAAoB,CACrB,AACD,0BACA,mCACM,eAAgB,AAChB,mBAAoB,AACpB,iBAAmB,CACxB,CACA,AACD,8BACE,sBAA0B,AAC1B,iBAAmB,CACpB,AACD,0BACA,8BACM,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,gBAAkB,CACvB,CACA,AACD,mCACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,kBAAmB,AACnB,WAAa,CACd,AACD,0BACA,mCACM,iBAAmB,CACxB,CACA,AACD,sCACE,kBAAoB,CACrB","file":"app-contact.vue","sourcesContent":["\n.name-contactanos[data-v-47aedbee] {\n  color: #05316a;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 40px;\n  margin-bottom: 68px;\n}\n@media (max-width: 1024px) {\n.name-contactanos[data-v-47aedbee] {\n      font-size: 30px;\n      margin-bottom: 43px;\n      text-align: center;\n}\n}\n.app-contact[data-v-47aedbee] {\n  background-color: #ffffff;\n  position: relative;\n}\n@media (max-width: 1024px) {\n.app-contact[data-v-47aedbee] {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      padding-top: 59px;\n}\n}\n.item-information[data-v-47aedbee] {\n  color: #05316a;\n  font-family: 'Lato', sans-serif;\n  font-weight: 300;\n  font-size: 20px;\n  margin: 0 0 0 14px;\n  width: 300px;\n}\n@media (max-width: 1024px) {\n.item-information[data-v-47aedbee] {\n      text-align: center;\n}\n}\n.content-information[data-v-47aedbee] {\n  margin-bottom: 35px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_contact_vue__ = __webpack_require__(533);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2d73fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_contact_vue__ = __webpack_require__(555);
function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b2d73fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2d73fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("9a29402c", content, true);

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".form-contact[data-v-5b2d73fc]{background-color:#fff;-webkit-box-shadow:0 2px 53px 0 rgba(0,0,0,.07);box-shadow:0 2px 53px 0 rgba(0,0,0,.07);max-width:475px;padding:45px 35px;position:relative;top:105px}@media (max-width:1024px){.form-contact[data-v-5b2d73fc]{margin:0 30px;padding:40px 24px;top:50px}}@media (max-width:380px){.form-contact[data-v-5b2d73fc]{margin:0 10px}}.title-form-contact[data-v-5b2d73fc]{color:#05316a;font-family:Lato,sans-serif;font-weight:900;font-size:25px;margin-bottom:50px;text-align:center}.btn-submit[data-v-5b2d73fc]{background-color:#3bb4c1;border-radius:9px;color:#fff;font-family:Lato,sans-serif;font-weight:900;font-size:18px;height:60px;width:100%}.input-form[data-v-5b2d73fc]{border:1px solid #e1e1e1;border-radius:9px;color:#d1d1d1;font-size:18px;margin-bottom:15px;padding:20px 0 20px 18px;outline:none;width:100%}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/form-contact.vue"],"names":[],"mappings":"AACA,+BACE,sBAA0B,AAC1B,gDAAqD,AAC7C,wCAA6C,AACrD,gBAAiB,AACjB,kBAAmB,AACnB,kBAAmB,AACnB,SAAW,CACZ,AACD,0BACA,+BACM,cAAe,AACf,kBAAmB,AACnB,QAAU,CACf,CACA,AACD,yBACA,+BACM,aAAe,CACpB,CACA,AACD,qCACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,mBAAoB,AACpB,iBAAmB,CACpB,AACD,6BACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,YAAa,AACb,UAAY,CACb,AACD,6BACE,yBAA0B,AAC1B,kBAAmB,AACnB,cAAe,AACf,eAAgB,AAChB,mBAAoB,AACpB,yBAA0B,AAC1B,aAAc,AACd,UAAY,CACb","file":"form-contact.vue","sourcesContent":["\n.form-contact[data-v-5b2d73fc] {\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 2px 53px 0 rgba(0, 0, 0, 0.07);\n          box-shadow: 0 2px 53px 0 rgba(0, 0, 0, 0.07);\n  max-width: 475px;\n  padding: 45px 35px;\n  position: relative;\n  top: 105px;\n}\n@media (max-width: 1024px) {\n.form-contact[data-v-5b2d73fc] {\n      margin: 0 30px;\n      padding: 40px 24px;\n      top: 50px;\n}\n}\n@media (max-width: 380px) {\n.form-contact[data-v-5b2d73fc] {\n      margin: 0 10px;\n}\n}\n.title-form-contact[data-v-5b2d73fc] {\n  color: #05316a;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 25px;\n  margin-bottom: 50px;\n  text-align: center;\n}\n.btn-submit[data-v-5b2d73fc] {\n  background-color: #3bb4c1;\n  border-radius: 9px;\n  color: #ffffff;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 18px;\n  height: 60px;\n  width: 100%;\n}\n.input-form[data-v-5b2d73fc] {\n  border: solid 1px #e1e1e1;\n  border-radius: 9px;\n  color: #d1d1d1;\n  font-size: 18px;\n  margin-bottom: 15px;\n  padding: 20px 0 20px 18px;\n  outline: none;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-contact",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_c('p',{staticClass:"title-form-contact"},[_vm._v("QUEREMOS CONOCERTE")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"input-form",attrs:{"type":"text","id":"name","placeholder":"Nombre","autocomplete":"off"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"input-form",attrs:{"type":"email","id":"email","placeholder":"Correo","autocomplete":"off"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.commentary),expression:"form.commentary"}],staticClass:"input-form",attrs:{"placeholder":"Mensaje","type":"text","cols":"4","rows":"4"},domProps:{"value":(_vm.form.commentary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "commentary", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn-submit",attrs:{"disabled":_vm.disabled}},[_vm._v("Enviar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"app-contact",attrs:{"id":"app-contact","xs12":"","justify-center":"","row":"","align-center":""}},[_c('v-flex',{attrs:{"md4":"","xs8":""}},[_c('v-flex',{staticClass:"name-contactanos"},[_vm._v("CONTÁCTANOS")]),_vm._v(" "),_vm._l((_vm.information),function(item,index){return _c('v-layout',{key:index,staticClass:"content-information",attrs:{"row":"","align-center":""}},[_c('img',{attrs:{"src":item.icon,"alt":"","width":"20"}}),_vm._v(" "),_c('p',{staticClass:"item-information"},[_vm._v(_vm._s(item.name))])])})],2),_vm._v(" "),_c('v-flex',{staticClass:"content-form",attrs:{"xs12":"","md4":""}},[_c('form-contact')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__ = __webpack_require__(534);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a2264d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__ = __webpack_require__(560);
function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a2264d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a2264d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(559);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("a5eb6c44", content, true);

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".app-footer[data-v-2a2264d3]{background-color:#41c8ce;height:514px;padding-top:66px}@media (max-width:1024px){.app-footer[data-v-2a2264d3]{height:1125px;padding-top:110px}}.title-footer[data-v-2a2264d3]{color:#fff;font-family:Lato,sans-serif;font-weight:700;font-size:16px;margin-bottom:35px}@media (max-width:960px){.title-footer[data-v-2a2264d3]{text-align:center}}.item-footer[data-v-2a2264d3]{color:#fff;font-family:Lato,sans-serif;font-weight:400;font-size:16px;margin-bottom:30px}@media (max-width:1024px){.item-footer[data-v-2a2264d3]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.content-links[data-v-2a2264d3]{display:grid;grid-template-columns:auto auto;position:relative;top:120px}@media (max-width:960px){.content-links[data-v-2a2264d3]{grid-template-columns:auto}}.reserved[data-v-2a2264d3]{background-color:#3bb4c1;color:#fff;font-family:Lato,sans-serif;font-weight:400;font-size:14px;padding:15px 0;position:relative}.item-link[data-v-2a2264d3]{color:#fff;text-align:center;text-decoration:none;margin:0}.company-logos[data-v-2a2264d3]{display:grid;grid-template-columns:auto auto auto;grid-column-gap:100px;grid-row-gap:50px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:71px}@media (max-width:960px){.company-logos[data-v-2a2264d3]{grid-template-columns:auto auto;grid-column-gap:29px}}.item-company[data-v-2a2264d3]{opacity:.43}.item-company[data-v-2a2264d3]:hover{-webkit-transform:scale(1.1);transform:scale(1.1);-webkit-transition:all .3s ease-out 0s;transition:all .3s ease-out 0s;opacity:1}@media (max-width:1024px){.item-company[data-v-2a2264d3]{opacity:1;-webkit-transform:none!important;transform:none!important}}.item-company[data-v-2a2264d3]:nth-child(7){grid-column:2/3}@media (max-width:960px){.item-company[data-v-2a2264d3]:nth-child(7){grid-column:1/3}}@media (max-width:1024px){.column-responsive[data-v-2a2264d3]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-bottom:55px}}@media (max-width:960px){.logo-apprunn[data-v-2a2264d3]{width:128px}}.links-footer[data-v-2a2264d3]:first-child{margin-bottom:54px}.text-decoration-none[data-v-2a2264d3]{text-decoration:none}.section-links-networks[data-v-2a2264d3]{background-color:#3bb4c1;border-top-left-radius:9px;border-top-right-radius:9px;bottom:45px;left:50%;padding:9px 0;position:absolute;-webkit-transform:translateX(-50%);transform:translateX(-50%);width:200px}.border-right[data-v-2a2264d3]{border-right:1px solid #fff}.border-right[data-v-2a2264d3]:last-child{border-right:none!important}.desktop-link-responsive[data-v-2a2264d3]{display:none}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/app-footer.vue"],"names":[],"mappings":"AACA,6BACE,yBAA0B,AAC1B,aAAc,AACd,gBAAkB,CACnB,AACD,0BACA,6BACM,cAAe,AACf,iBAAmB,CACxB,CACA,AACD,+BACE,WAAe,AACf,4BAAgC,AAChC,gBAAkB,AAClB,eAAgB,AAChB,kBAAoB,CACrB,AACD,yBACA,+BACM,iBAAmB,CACxB,CACA,AACD,8BACE,WAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,kBAAoB,CACrB,AACD,0BACA,8BACM,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACrC,CACA,AACD,gCACE,aAAc,AACd,gCAAiC,AACjC,kBAAmB,AACnB,SAAW,CACZ,AACD,yBACA,gCACM,0BAA4B,CACjC,CACA,AACD,2BACE,yBAA0B,AAC1B,WAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,eAAgB,AAChB,iBAAmB,CACpB,AACD,4BACE,WAAe,AACf,kBAAmB,AACnB,qBAAsB,AACtB,QAAU,CACX,AACD,gCACE,aAAc,AACd,qCAAsC,AACtC,sBAAuB,AACvB,kBAAmB,AACnB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,eAAiB,CAClB,AACD,yBACA,gCACM,gCAAiC,AACjC,oBAAsB,CAC3B,CACA,AACD,+BACE,WAAc,CACf,AACD,qCACI,6BAA8B,AACtB,qBAAsB,AAC9B,uCAAyC,AACzC,+BAAiC,AACjC,SAAW,CACd,AACD,0BACA,+BACM,UAAW,AACX,iCAAmC,AAC3B,wBAA2B,CACxC,CACA,AACD,4CACE,eAAmB,CACpB,AACD,yBACA,4CACM,eAAmB,CACxB,CACA,AACD,0BACA,oCACI,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,mBAAqB,CACxB,CACA,AACD,yBACA,+BACI,WAAa,CAChB,CACA,AACD,2CACE,kBAAoB,CACrB,AACD,uCACE,oBAAsB,CACvB,AACD,yCACE,yBAA0B,AAC1B,2BAA4B,AAC5B,4BAA6B,AAC7B,YAAa,AACb,SAAU,AACV,cAAe,AACf,kBAAmB,AACnB,mCAAoC,AAC5B,2BAA4B,AACpC,WAAa,CACd,AACD,+BACE,2BAA8B,CAC/B,AACD,0CACI,2BAA8B,CACjC,AACD,0CACE,YAAc,CACf","file":"app-footer.vue","sourcesContent":["\n.app-footer[data-v-2a2264d3] {\n  background-color: #41c8ce;\n  height: 514px;\n  padding-top: 66px;\n}\n@media (max-width: 1024px) {\n.app-footer[data-v-2a2264d3] {\n      height: 1125px;\n      padding-top: 110px;\n}\n}\n.title-footer[data-v-2a2264d3] {\n  color: #ffffff;\n  font-family: 'Lato', sans-serif;\n  font-weight: bold;\n  font-size: 16px;\n  margin-bottom: 35px;\n}\n@media (max-width: 960px) {\n.title-footer[data-v-2a2264d3] {\n      text-align: center;\n}\n}\n.item-footer[data-v-2a2264d3] {\n  color: #ffffff;\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n@media (max-width: 1024px) {\n.item-footer[data-v-2a2264d3] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n}\n.content-links[data-v-2a2264d3] {\n  display: grid;\n  grid-template-columns: auto auto;\n  position: relative;\n  top: 120px;\n}\n@media (max-width: 960px) {\n.content-links[data-v-2a2264d3] {\n      grid-template-columns: auto;\n}\n}\n.reserved[data-v-2a2264d3] {\n  background-color: #3bb4c1;\n  color: #ffffff;\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  padding: 15px 0;\n  position: relative;\n}\n.item-link[data-v-2a2264d3] {\n  color: #ffffff;\n  text-align: center;\n  text-decoration: none;\n  margin: 0;\n}\n.company-logos[data-v-2a2264d3] {\n  display: grid;\n  grid-template-columns: auto auto auto;\n  grid-column-gap: 100px;\n  grid-row-gap: 50px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 71px;\n}\n@media (max-width: 960px) {\n.company-logos[data-v-2a2264d3] {\n      grid-template-columns: auto auto;\n      grid-column-gap: 29px;\n}\n}\n.item-company[data-v-2a2264d3] {\n  opacity: 0.43;\n}\n.item-company[data-v-2a2264d3]:hover {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n    -webkit-transition: all 0.3s ease-out 0s;\n    transition: all 0.3s ease-out 0s;\n    opacity: 1;\n}\n@media (max-width: 1024px) {\n.item-company[data-v-2a2264d3] {\n      opacity: 1;\n      -webkit-transform: none !important;\n              transform: none !important;\n}\n}\n.item-company[data-v-2a2264d3]:nth-child(7) {\n  grid-column: 2 / 3;\n}\n@media (max-width: 960px) {\n.item-company[data-v-2a2264d3]:nth-child(7) {\n      grid-column: 1 / 3;\n}\n}\n@media (max-width: 1024px) {\n.column-responsive[data-v-2a2264d3] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    padding-bottom: 55px;\n}\n}\n@media (max-width: 960px) {\n.logo-apprunn[data-v-2a2264d3] {\n    width: 128px;\n}\n}\n.links-footer[data-v-2a2264d3]:nth-child(1) {\n  margin-bottom: 54px;\n}\n.text-decoration-none[data-v-2a2264d3] {\n  text-decoration: none;\n}\n.section-links-networks[data-v-2a2264d3] {\n  background-color: #3bb4c1;\n  border-top-left-radius: 9px;\n  border-top-right-radius: 9px;\n  bottom: 45px;\n  left: 50%;\n  padding: 9px 0;\n  position: absolute;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  width: 200px;\n}\n.border-right[data-v-2a2264d3] {\n  border-right: 1px solid white;\n}\n.border-right[data-v-2a2264d3]:last-child {\n    border-right: none !important;\n}\n.desktop-link-responsive[data-v-2a2264d3] {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{staticClass:"app-footer",attrs:{"justify-center":""}},[_c('v-layout',{staticClass:"column-responsive",attrs:{"row":"","xs12":"","align-center":""}},[_c('v-layout',{attrs:{"column":"","text-xs-center":""}},[_c('v-flex',[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo-apprunn",attrs:{"src":"https://web-apprunn.s3-sa-east-1.amazonaws.com/logo-apprunn.svg","alt":""}})])]),_vm._v(" "),_c('v-flex',[_c('v-flex',{staticClass:"company-logos",attrs:{"align-center":""}},_vm._l((_vm.logosCompany),function(item,index){return _c('div',{key:index,staticClass:"item-company"},[_c('img',{style:(("width: " + (item.width))),attrs:{"src":item.logo,"alt":""}})])}),0)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"content-links"},_vm._l((_vm.linksFooter),function(item,index){return _c('v-flex',{key:index,staticClass:"links-footer",attrs:{"column":""}},[_c('p',{staticClass:"title-footer"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_vm._l((item.items),function(link,index){return _c('v-layout',{key:index,staticClass:"item-footer"},[_c('a',{staticClass:"item-link",attrs:{"href":link.href}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(link.name)+"\n\t\t\t\t\t\t")])])})],2)}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"reserved",attrs:{"text-xs-center":""}},[_c('v-layout',{class:_vm.windowSize.x < 1024 ? 'section-links-networks' : 'desktop-link-responsive',attrs:{"justify-center":"","row":"","align-center":""}},_vm._l((_vm.links),function(icon,index){return _c('v-flex',{key:index,staticClass:"border-right"},[_c('a',{attrs:{"href":icon.link}},[_c('img',{style:(("width: " + (icon.width) + "px")),attrs:{"src":icon.icon,"alt":""}})])])}),1),_vm._v("\n\t\t©2020 Derechos reservado Apprunn\n\t")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"},{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],attrs:{"id":"home"}},[_c('app-sidebar',{attrs:{"active":_vm.active,"items":_vm.items},on:{"change-active":_vm.changeActive,"close-modal":_vm.closeModal}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('app-contact',{attrs:{"information":_vm.information}}),_vm._v(" "),_c('app-footer',{attrs:{"window-size":_vm.windowSize,"logos-company":_vm.logosCompany,"links-footer":_vm.linksFooter}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.3ba74009043308dfadfd.js